// Shared "date the client took the assessment" formatter.
// F17 (McKayla Loom "Nitrogen Layout Part 1" t=2:12, ClickUp 86bah7dqn):
// "personality, what date they took it." Rendered on both the advisor
// Overview tab and the Money Personality tab, so it lives here rather than in
// either component — a component importing a helper out of a sibling component
// is how two copies of this drift apart.
//
// Returns null (never a placeholder string, never today's date) when the input
// is missing or unparseable, so callers can omit the line entirely rather than
// showing an invented date.
export function formatQuizDate(iso: string | undefined | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
